import { animate, inView } from "motion";

const initVideoScrollAnimation = () => {
    const videoElements = document.querySelectorAll(".video");

    if (!videoElements.length) return;

    videoElements.forEach((video) => {
        const videoWrapper = video.querySelector(".video__wrapper");
        const textWrapper = video.querySelector(".video__text-wrapper");
        if (!videoWrapper) return;

        const isDesktop = window.matchMedia("(min-width: 1024px)").matches;

        if (!isDesktop) {
            animate(videoWrapper, { scale: 1 }, { duration: 0 });
            if (textWrapper) {
                animate(textWrapper, { scale: 1, y: 0, opacity: 1 }, { duration: 0 });
            }
            return;
        }

        animate(videoWrapper, { scale: 0.5 }, { duration: 0 });
        if (textWrapper) {
            animate(textWrapper, { scale: 0.3, y: 20, opacity: 0 }, { duration: 0 });
        }

        inView(
            videoWrapper,
            () => {
                animate(
                    videoWrapper,
                    { scale: 1 },
                    {
                        duration: 1.5,
                        ease: [0.4, 0, 0.2, 1],
                    }
                );

                if (textWrapper) {
                    animate(
                        textWrapper,
                        {
                            scale: 1,
                            y: 0,
                            opacity: 1,
                        },
                        {
                            duration: 0.75,
                            delay: 0.75,
                            ease: [0.4, 0, 0.2, 1],
                        }
                    );
                }
            },
            {
                amount: "all",
            }
        );
    });
};

const handleResize = () => {
    initVideoScrollAnimation();
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initVideoScrollAnimation);
} else {
    initVideoScrollAnimation();
}

window.addEventListener("resize", handleResize);
